import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IMaster, IMasterCreatePayload, IMasterUpdatePayload, MasterType } from "../../../types/api/master";
import { AxiosResponse } from "axios";

export async function masterList(
  qData: QData & { type?: MasterType; search?: string }
): Promise<AxiosResponse<TResponseWithQData<IMaster[]>>> {
  return axios.get(API_ENDPOINTS.MASTER_LIST, { params: qData });
}

export async function masterDetail(
  id: string
): Promise<AxiosResponse<TResponse<IMaster>>> {
  return axios.get(`${API_ENDPOINTS.MASTER_DETAIL}/${id}`);
}

export async function createMaster(
  data: IMasterCreatePayload
): Promise<AxiosResponse<TResponse<IMaster>>> {
  return axios.post<TResponse<IMaster>>(API_ENDPOINTS.MASTER_CREATE, data);
}

export async function updateMaster(
  data: IMasterUpdatePayload
): Promise<AxiosResponse<TResponse<IMaster>>> {
  const { _id, ...rest } = data;
  return axios.put<TResponse<IMaster>>(`${API_ENDPOINTS.MASTER_UPDATE}/${_id}`, rest);
}

export async function deleteMaster(
  id: string
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete<TResponse<null>>(`${API_ENDPOINTS.MASTER_DELETE}/${id}`);
}
